import { Text as TextWrapper } from '@oneaudi/unified-web-components';
import { UeElement } from '@oneaudi/falcon-tools';
import React, { memo } from 'react';
import styled from 'styled-components';
import { convertRichText } from './textUtils';

const StyledText = styled.span`
  sup {
    position: initial;
    line-height: initial;
  }

  & p {
    padding: 0;

    & + p {
      margin-block-start: var(--relative-spacing-md);
    }
  }
`;

export interface TextProps {
  readonly text: string;
  readonly property: string;
}

export default memo(function Text({ text, property }: TextProps) {
  return (
    <UeElement type="text" property={property} label="Text">
      <TextWrapper tag="span">
        <StyledText>{convertRichText(text)}</StyledText>
      </TextWrapper>
    </UeElement>
  );
});
